/**
 * Navbar.js — Top bar inside the app shell (mobile-first).
 */
import React from 'react';
import { useAppContext } from '../context/AppContext';

function Navbar() {
    const { user, handleLogout, isSampleMode, clearSampleData } = useAppContext();

    const handleReturnHome = () => {
        if (isSampleMode) {
            clearSampleData();
        }
        handleLogout();
    };

    return (
        <nav className="app-navbar">
            <div className="nav-content">
                <div className="logo" style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
                    <span
                        className="navbar-logo-mobile-only"
                        style={{
                            fontFamily: 'var(--font-logo)',
                            fontWeight: 700,
                            fontSize: '20px',
                            letterSpacing: '-0.5px',
                            color: 'var(--text-primary)',
                            marginRight: '8px',
                        }}
                    >
                        spenderly
                    </span>
                    {isSampleMode && (
                        <span className="demo-badge">Demo</span>
                    )}
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
                    <a
                        className="nav-feedback-link"
                        href="https://mail.google.com/mail/?view=cm&fs=1&to=support@spenderly.in&su=Feedback%20for%20Spenderly"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Feedback
                    </a>
                    {user && (
                        <button type="button" className="nav-logout-btn" onClick={handleReturnHome}>
                            {isSampleMode ? 'Exit' : 'Leave'}
                        </button>
                    )}
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
